document.addEventListener('DOMContentLoaded', function () {
    var BirdySmAccordion = function(el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        var chevrons = this.el.querySelectorAll('.bi-chevron-down');
        chevrons.forEach(chevron => {
            chevron.addEventListener('click', (e) => {
                e.stopPropagation();
                this.dropdown(e);
            });
        });

        this.el.querySelectorAll('li').forEach(li => {
            var submenu = li.querySelector('.submenu');
            var chevron = li.querySelector('.bi-chevron-down');
            if (submenu) {
                if (chevron) {
                    chevron.style.display = 'inline';
                }
            } else {
                if (chevron) {
                    chevron.style.display = 'none';
                }
            }
        });
    };

    BirdySmAccordion.prototype.dropdown = function(e) {
        var $el = this.el;
        var $chevron = e.currentTarget;
        var $submenu = $chevron.parentElement.nextElementSibling;

        if ($submenu) {
            if ($submenu.style.height && $submenu.style.height !== '0px') {
                // Collapse the current submenu
                $submenu.style.height = '0px';
                $chevron.style.transform = 'scaleY(1)'; // Flip back to original
            } else {
                if (!this.multiple) {
                    // Close all other submenus and reset their chevrons
                    $el.querySelectorAll('.submenu').forEach(submenu => {
                        if (submenu !== $submenu) {
                            submenu.style.height = '0px';
                            var otherChevron = submenu.previousElementSibling.querySelector('.bi-chevron-down');
                            if (otherChevron) {
                                otherChevron.style.transform = 'scaleY(1)'; // Reset flip
                            }
                        }
                    });
                }
                // Expand the current submenu
                $submenu.style.height = $submenu.scrollHeight + 'px';
                $chevron.style.transform = 'scaleY(-1)'; // Flip the chevron vertically
            }

            // Toggle the "open" class on the parent element
            $chevron.parentElement.parentElement.classList.toggle('open');
        }
    };

    // Initialize the accordion
    var birdysmaccordion = new BirdySmAccordion(document.getElementById('birdy-sm-nav-accordion'), false);
});
